<template>
  <v-text-field
    v-model="model"
    density="compact"
    variant="outlined"
    color="orange50"
    hide-details="auto"
    :placeholder="placeholder"
    :error-messages="errorMessage"
    class="wd-flex-grow-0 wd-w-full md:wd-w-1/2"
    @blur="$emit('blur')"
  />
</template>

<script setup lang="ts">
import type { MemberFormValue } from '@/view-models/member'

interface Props {
  errorMessage?: string
  placeholder?: string
}

defineProps<Props>()

defineEmits<{
  blur: []
}>()

const model = defineModel<MemberFormValue>()
</script>
